<template>
  <div class="sub-aspect-detail">
    <router-link :to="{ name: 'PsychogramManager' }" class="back-link">&larr; Kembali ke Manajemen Psikogram</router-link>
    
    <div v-if="isLoading">
      <div class="loading-spinner"></div>
    </div>
    <div v-else-if="subAspect">
      <header class="page-header">
        <h1>Kelola Tes untuk: {{ subAspect.name }}</h1>
        <p>Pilih satu atau lebih Master Tes yang digunakan untuk mengukur sub-aspek ini. Perubahan akan disimpan secara otomatis.</p>
      </header>

      <div class="card">
        <div v-if="masterTests.length > 0" class="test-selection-list">
          <label v-for="test in masterTests" :key="test.id" class="test-item" :class="{ 'is-selected': isTestAssociated(test.id) }">
            <input
              type="checkbox"
              :id="`test-${test.id}`"
              :checked="isTestAssociated(test.id)"
              @change="toggleTestAssociation(test.id, $event)"
              :disabled="isSaving === test.id"
            />
            <span class="test-name">{{ test.name }}</span>
            <div class="spinner-sm" v-if="isSaving === test.id"></div>
          </label>
        </div>
        <p v-else>Tidak ada master tes yang tersedia.</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import apiClient from '@/services/api.js';

const route = useRoute();
const subAspectId = route.params.id;
    
const isLoading = ref(true);
const isSaving = ref(null); // Menyimpan ID tes yang sedang disimpan
const subAspect = ref(null);
const masterTests = ref([]);
    
const isTestAssociated = (testId) => {
  if (!subAspect.value || !subAspect.value.tests) return false;
  return subAspect.value.tests.some(t => t.id === testId);
};

const toggleTestAssociation = async (testId, event) => {
  const isChecked = event.target.checked;
  isSaving.value = testId; // Tampilkan spinner di item yang benar
  
  try {
    let response;
    if (isChecked) {
      response = await apiClient.post(`/admin/sub-aspects/${subAspectId}/tests/${testId}`);
    } else {
      response = await apiClient.delete(`/admin/sub-aspects/${subAspectId}/tests/${testId}`);
    }
    // Update state lokal dengan data terbaru dari server
    subAspect.value = response.data;
  } catch (error) {
    alert("Gagal mengubah asosiasi tes. Perubahan dibatalkan.");
    console.error(error);
    // Kembalikan checkbox ke state semula jika API gagal
    event.target.checked = !isChecked;
  } finally {
    isSaving.value = null; // Sembunyikan spinner
  }
};

const fetchSubAspectDetail = async () => {
  const response = await apiClient.get(`/admin/sub-aspects/${subAspectId}`);
  subAspect.value = response.data;
};
    
const fetchMasterTests = async () => {
  const response = await apiClient.get('/admin/tests/master-list?limit=1000');
  masterTests.value = response.data.tests;
};

onMounted(async () => {
  isLoading.value = true;
  try {
    await Promise.all([fetchSubAspectDetail(), fetchMasterTests()]);
  } catch (error) {
    console.error("Gagal memuat data:", error);
  } finally {
    isLoading.value = false;
  }
});
</script>

<style scoped>
.sub-aspect-detail { max-width: 800px; margin: auto; padding: 20px; }
.back-link { /* ... (style dari halaman lain) ... */ }
.page-header { margin-bottom: 20px; }
h1 { margin-bottom: 5px; }
p { color: #555; }
.card { background: #fff; padding: 20px; border-radius: 8px; box-shadow: 0 2px 8px rgba(0,0,0,0.05); }

.test-selection-list { display: flex; flex-direction: column; gap: 10px; }
.test-item {
  display: flex;
  align-items: center;
  padding: 15px;
  border: 1px solid #eee;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease;
}
.test-item:hover {
  background-color: #f8f9fa;
  border-color: #ddd;
}
.test-item.is-selected {
  background-color: #e8f5e9; /* Hijau muda */
  border-color: #a5d6a7;
}
.test-item input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin-right: 15px;
}
.test-name {
  flex-grow: 1; /* Dorong spinner ke kanan */
  font-weight: 500;
}
.spinner-sm {
  border: 2px solid #f3f3f3;
  border-top: 2px solid #3498db;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
</style>